import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiResult } from '../../models/ApiResult';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { LocalizationService } from '../../services/localization.service';
import { TestigosService } from '../../services/testigos.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { TestigoModel } from '../../models/TestigoModel';
import { ModelHelpers } from '../../models/ModelHelpers';


@Component({
  selector: 'app-testigos-edit',
  templateUrl: './testigos-edit.component.html',
  styleUrls: ['./testigos-edit.component.scss']
})
export class TestigosEditComponent implements OnInit {

  @ViewChild('places', { static: false }) places: GooglePlaceDirective;
  testigoForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  isModal: boolean;
  errorMessage: String = '';
  localization: LocalizationService;
  options: any = {
    format: 'DD/MM/YYYY'
  };
  tipoTestigoList: any;
  testigoEstadoList: any;
  estadoLocalizacionList:any;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _testigosService: TestigosService,
    public dialogRef: MatDialogRef<TestigosEditComponent>, private _location: Location, localization: LocalizationService,
    public dateHelper: DateHelper,) {

    this.localization = localization;

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.testigoForm = this._fb.group({
      id: 0,
      valorGlobal: ['', Validators.required],
      fechaAnalisis: ['', Validators.required],
      //tipoTestigo: [''],
      tipoTestigoId: ['', Validators.required],
      supTotal: ['', Validators.required],
      valorUnitario: ['', Validators.required],
      anioConstr: ['', Validators.required],
      direccion: ['', Validators.required],
      tlfContacto: [''],
      //testigoEstado: [''],
      testigoEstadoId: ['', Validators.required],
      tipologia: ['', Validators.required],
      localizacionTestigoId: ['', Validators.required],
      //Balcon
      pondB: [''],
      areaB: [''],
      precioB: [''],

      //Trastero
      pondT: [''],
      areaT: [''],
      precioT: [''],

      //Garage
      tipoGaraje: [null],
      nPlazas: [''],
      precioG: [''],

      latitude: [''],
      longitude: [''],
    });
  }

  ngOnInit() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";
      this._testigosService.getTestigo(this.id)
        .subscribe((resp:TestigoModel)=> {
          this.testigoForm.setValue(resp);
          console.log(resp);

        }
          , error => {
            this.errorMessage = error;
          });
    } else {
      this.isNewElement = true;
    }

    this._testigosService.getTipo().subscribe(data => this.tipoTestigoList = data);
    this._testigosService.getEstado().subscribe(data => this.testigoEstadoList = data);
    this._testigosService.getEstadoLocalizacion().subscribe(data => this.estadoLocalizacionList = data);
  }



  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  onSaved(value: ApiResult | null) {
    if (value.correct) {
      if (!this.isModal) {
        this._location.back();
      } else {
        this.closeDialog();
      }
    } else {
      if (value !== null) {
        this.errorMessage = value.mensaje;
      } else {
        this.errorMessage = 'Error interno';
      }
    }
  }

  save() {
    if (!this.testigoForm.valid) {
      return;
    }

    let testigoModel = new TestigoModel();
    ModelHelpers.copyFromForm(this.testigoForm.value, testigoModel);
    if (this.isNewElement) {
      this._testigosService.postTestigo(testigoModel)
        .subscribe({
          next: (value) => {
            this.onSaved(value);
          },
          error: (err) => {
            console.log(err);
            this.onSaved(null);
          }
        });
    } else {
      this._testigosService.updateTestigo(testigoModel)
        .subscribe({
          next: (value) => {
            this.onSaved(value);
          },
          error: (err) => {
            console.log(err);
            this.onSaved(null);
          }
        });
    }
  }

  public onChange(address: any) {
    console.log('Address components:');
    var p = address.geometry.location
    this.testigoForm.controls['latitude'].setValue(p.lat());
    this.testigoForm.controls['longitude'].setValue(p.lng());
  }

  get tipoValor() { return this.testigoForm.get('tipoValor'); }
  get valorGlobal() { return this.testigoForm.get('valorGlobal'); }
  get fechaAnalisis() { return this.testigoForm.get('fechaAnalisis'); }
  get tipoTestigoId() { return this.testigoForm.get('tipoTestigoId'); }
  get supTotal() { return this.testigoForm.get('supTotal'); }
  get valorUnitario() { return this.testigoForm.get('valorUnitario'); }
  get anioConstr() { return this.testigoForm.get('anioConstr'); }
  get direccion() { return this.testigoForm.get('direccion'); }
  get testigoEstadoId() { return this.testigoForm.get('testigoEstadoId'); }
  get tipologia() { return this.testigoForm.get('tipologia'); }

  //Balcones
  get pondB() { return this.testigoForm.get('pondB');}
  get areaB() { return this.testigoForm.get('areaB');}
  get precioB() { return this.testigoForm.get('precioB');}
  //Terraza
  get pondT() { return this.testigoForm.get('pondT');}
  get areaT() { return this.testigoForm.get('areaT');}
  get precioT() { return this.testigoForm.get('precioT');}
  //Garage
  get tipoG() { return  this.testigoForm.get('tipoG');}
  get nPlazas() { return  this.testigoForm.get('nPlazas');}
  get precioG() { return  this.testigoForm.get('precioG');}

  get localizacionTestigoId() { return this.testigoForm.get('localizacionTestigoId')}
}
